import * as types from './types'
import storage from '@/plugins/storage'
export default () => ({
  status: storage.session.getItem(types.SESSION_STATUS) || '',
  endDate: storage.session.getItem(types.SESSION_END_DATE) || null,
  pageSize: storage.session.getItem(types.SESSION_PAGE_SIZE) || 10,
  retrospectiveDay: storage.session.getItem(types.SESSION_DAYS) || 1,
  searchTerm: storage.session.getItem(types.SESSION_SEARCH_TERM) || '',
  startDate: storage.session.getItem(types.SESSION_START_DATE) || null,
  view: storage.session.getItem(types.SESSION_VIEW) || 'CompletedNoMasterTech',
  kpis: [],
  device: [],
  dataRecords: [],
  countDataListing: 0,
  dataCompanyNumberScansOverall: JSON.parse(storage.session.getItem(types.SESSION_COMPANY_NUMBER_SCANS_OVERALL)) || [],
  dataCompanyNumberScans: JSON.parse(storage.session.getItem(types.SESSION_COMPANY_NUMBER_SCANS)) || [],
  dataCompanyAvgScanTimes: JSON.parse(storage.session.getItem(types.SESSION_COMPANY_AVG_SCAN_TIMES)) || [],
  dataPersonalYesterdayScans: JSON.parse(storage.session.getItem(types.SESSION_PERSONAL_YESTERDAY_SCANS)) || [],
  dataPersonalAvgScans: JSON.parse(storage.session.getItem(types.SESSION_PERSONAL_AVG_SCANS)) || [],
  dataPersonalAvgScanTimes: JSON.parse(storage.session.getItem(types.SESSION_PERSONAL_AVG_SCAN_TIMES)) || [],
  dataPersonalAvgCycleTimes: JSON.parse(storage.session.getItem(types.SESSION_PERSONAL_AVG_CYCLE_TIMES)) || [],
  widgetLoaded: [],
  technicians: [],
  tech: null
})



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/state.js